import { render, staticRenderFns } from "./V2DragAndDrop.vue?vue&type=template&id=6550b6d4&scoped=true&"
import script from "./V2DragAndDrop.vue?vue&type=script&lang=js&"
export * from "./V2DragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./V2DragAndDrop.vue?vue&type=style&index=0&id=6550b6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6550b6d4",
  null
  
)

export default component.exports